import React, { Component, Fragment } from 'react'
import axios, { getAccessToken, getParticipantInfo } from '../Shared/axios'
import { requestGetApi } from '../Shared/utils'
import { Helmet } from 'react-helmet'
import CreditApprovalModal from './CreditApprovalModal'
import Loading from '../Shared/Loading'
import PropTypes from 'prop-types'
import '../Participant/ParticipantDistributionPoint.css'

class CreditApprovalDetails extends Component {
  constructor (props) {
    super(props)
    this.state = {
      creditId: this.props.history.location.state ? this.props.history.location.state.creditId : null,
      creditRequest: {
        creditRequest: {},
        transactions: []
      },
      loading: true,
      modal: false,
      modalType: 1,
      alertMessage: { message: '', type: 1 }
    }

    if (!this.props.history.location.state) this.navigate()
  }

  async componentDidMount () {
    await this.getCredit()
  }

  async getCredit () {
    this.updateState('loading', true)

    const response = await requestGetApi(`creditRequestTransaction/${this.state.creditId}`)

    this.updateState('creditRequest', response)
    this.updateState('loading', false)
  }

  navigate () {
    this.props.history.push({
      pathname: '/credit-approval',
      state: { alertMessage: this.state.alertMessage }
    })
  }

  async submit (creditId) {
    this.updateState('loading', true)
    this.toggleModal()

    const type = this.state.modalType

    const body = {
      creditRequestId: creditId,
      status: type
    }

    const participant = getParticipantInfo()

    const headers = {
      'Authorization': `Bearer ${getAccessToken()}`,
      'campaignId': `${participant['custom:campaign_id']}`,
      'catalogId': `${participant['custom:catalog_id']}`
    }

    await axios
      .post('creditRequest/approveReject', body, { headers })
      .then((res) => {
        console.log(res.data)
        this.updateState('alertMessage', {
          message: `O crédito foi ${type === 1 ? 'aprovado' : 'rejeitado'} com sucesso`,
          type: 1
        })
      }).catch((err) => {
        console.log(err)
        this.updateState('alertMessage', {
          message: `Ocorreu um erro ao ${type === 1 ? 'aprovar' : 'rejeitar'} o crédito`,
          type: 2
        })
      })
      .finally(() => {
        this.updateState('loading', false)
        this.navigate()
      })
  }

  updateState (field, value) {
    let state = this.state
    state[field] = value
    this.setState(state)
  }

  toggleModal () {
    let state = this.state
    state.modal = !state.modal
    this.setState(state)
  }

  approveReject (type) {
    this.updateState('modalType', type)
    this.toggleModal()
  }

  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Revisão de Crédito - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='container-fluid'>
          <div className='container'>
            <div className='row'>
              <div className='col-12 py-2'>
                <div className='row'>
                  <div className='col-12 border-color-ui-3 bg-white border radius'>
                    <div className='row px-3 py-2 border-bottom border-color-ui-3 '>
                      <div className='col-8 py-1'>
                        <h3 className='txt-initial color-brand-1 mr-auto'>
                          Revisão de Crédito - #{this.state.creditId}
                        </h3>
                      </div>
                      <div className='col-2 py-1'>
                        <button onClick={() => this.approveReject(1)}>
                          Aprovar
                        </button>
                      </div>
                      <div className='col-2 py-1'>
                        <button onClick={() => this.approveReject(2)}>
                          Recusar
                        </button>
                      </div>
                    </div>
                    {this.state.loading
                      ? (
                        <Loading
                          loading={this.state.loading}
                        />
                      )
                      : (
                        <Fragment>
                          {this.state.creditRequest.transactions.length > 0 &&
                            (
                              <div className='col-12 order-item'>
                                <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
                                  <div className='order-product-info col mr-auto'>
                                    <div className='order-product-info row'>
                                      <div className='product-infos col mx-0'>
                                        <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                                          Name
                                        </h3>
                                      </div>
                                      <div className='product-infos col mx-0'>
                                        <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                                          Login
                                        </h3>
                                      </div>
                                      <div className='product-infos col mx-0'>
                                        <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                                          Email
                                        </h3>
                                      </div>
                                      <div className='product-infos col mx-0'>
                                        <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                                          Pontos
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                          {this.state.creditRequest.transactions.map((t) => {
                            return (
                              <div className='col-12 order-item'>
                                <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
                                  <div className='order-product-info col mr-auto'>
                                    <div className='order-product-info row'>
                                      <div className='product-infos col-12 mx-0'>
                                        <h2 className='txt-font-body txt-subtitle body-text-title color-ui-2 mt-1'>
                                          {t.name}
                                        </h2>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='order-product-info col mr-auto'>
                                    <div className='order-product-info row'>
                                      <div className='product-infos col-12 mx-0'>
                                        <h2 className='txt-font-body txt-subtitle body-text-title color-ui-2 mt-1'>
                                          {t.login}
                                        </h2>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='order-product-info col mr-auto'>
                                    <div className='order-product-info row'>
                                      <div className='product-infos col-12 mx-0'>
                                        <h2 className='txt-font-body txt-subtitle body-text-title color-ui-2 mt-1'>
                                          {t.email}
                                        </h2>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='order-product-info col mr-auto'>
                                    <div className='order-product-info row'>
                                      <div className='product-infos col-12 mx-0'>
                                        <h2 className='txt-font-body txt-subtitle body-text-title color-ui-2 mt-1'>
                                          {t.value}
                                        </h2>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                        </Fragment>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
            { /* eslint-disable react/jsx-no-bind */ }
            <CreditApprovalModal
              modal={this.state.modal}
              creditId={this.state.creditId}
              type={this.state.modalType}
              value={this.state.creditRequest.creditRequest.value}
              toggleModal={this.toggleModal.bind(this)}
              submit={this.submit.bind(this)}
            />
            { /* eslint-enable react/jsx-no-bind */ }
          </div>
        </div>
      </Fragment>
    )
  }
}

CreditApprovalDetails.propTypes = {
  history: PropTypes.object
}

export default CreditApprovalDetails



// WEBPACK FOOTER //
// ./src/features/FocalPoint/CreditApproval/CreditApprovalDetails.js